


















import Vue from 'vue'
import Component from 'vue-class-component'
import Navigation from '@/components/Navigation.vue'
import { Watch } from 'vue-property-decorator'

@Component({
  components: {
    Navigation
  }
})
export default class App extends Vue {
  isNavOpen = this.$vuetify.breakpoint.mdAndUp;

  get isAppBarVisible () {
    if (!this.isNavigationVisible) {
      return false
    }
    return this.$vuetify.breakpoint.mdAndDown
  }

  private get isNavigationVisible () {
    return !this.$route.meta?.hidesNavigation
  }

  @Watch('$route', { immediate: true, deep: true })
  onUrlChange () {
    this.isNavOpen = this.$vuetify.breakpoint.mdAndUp
  }
}
